import * as React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';

interface RoleListViewProps extends ComponentViewProps<DataSet<RoleSummary>> {
	onItemDoubleClicked?: (item: RoleSummary) => any;
}


export class RoleListView extends React.Component<RoleListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	@autobind
	rowKey(record: RoleSummary): string {
		return record.id.toString();
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Role name',
				dataIndex: 'displayName',
				render: (text, record: RoleSummary) => <Link to={`/general/roles/${record.id}`}>{text}</Link>,
			},
			{
				key: 'isAdmin',
				title: 'Is Admin',
				dataIndex: 'isAdmin',
				render: (text: any, record: any, index: number) => <i className={`fa fa-${text == true ? "check-square-o" : "square-o"}`} />
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						rowKey={this.rowKey}
						hideToolbar={ToolbarVisibility.hideSearch}
						setBusy={this.props.setBusy}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/list/role-list.view.tsx